import { TotemPopup } from 'components/TotemPopup';

export type OdooOrderSupplier = {
    _id: string;
    name: string;
    odooSupplierId?: number | null;
};

export function getSuppliersMissingOdoo(suppliers: OdooOrderSupplier[]): OdooOrderSupplier[] {
    return Array.from(
        new Map(
            suppliers.filter((supplier) => !supplier.odooSupplierId).map((supplier) => [supplier._id, supplier]),
        ).values(),
    );
}

export function MissingOdooSupplierPopup({
    suppliers,
    isOpen,
    setIsOpen,
}: {
    suppliers: OdooOrderSupplier[];
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}) {
    return (
        <TotemPopup title="Association Odoo obligatoire" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div role="alert" className="rounded-lg border border-red-500 bg-red-50 p-4 text-red-700">
                <p>
                    Impossible de passer ces achats en « Commandé ». Associez chaque fournisseur à une organisation Odoo
                    et vérifiez son entité juridique depuis sa fiche avant de continuer.
                </p>
                <ul className="mt-3 list-disc pl-5">
                    {suppliers.map((supplier) => (
                        <li key={supplier._id}>
                            <a className="font-bold underline" href={`/supplier/${supplier._id}`}>
                                Corriger le fournisseur {supplier.name}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </TotemPopup>
    );
}
